export default {
  namespaced: true,

  state: {
    items: []
  },

  mutations: {
    set(state, items) {
      state.items = items;
    },

    retrieve(state) {
      if (!state.items.length) {
        window.Ajax.get('/credit-hire-charges')
          .then(response => {
            state.items = response.data;
          })
          .catch(err => {});
      }
    }
  },

  getters: {
    all(state) {
      return state.items;
    },

    charges(state) {
      return state.items.filter(item => item.extra === false);
    },

    extras(state) {
      return state.items.filter(item => item.extra === true);
    }
  }
};
